<template>
  <MModal
    v-if="open"
    @close="onClose"
    :mount-to="mountTo"
    :can-be-dismissed="!IS_MOBILE_APP"
    modal-class="md:max-w-3xl"
    mobile-fullscreen
  >
    <div class="px-4 py-6 md:p-8 md:rounded-6" :class="{ 'h-full md:bg-gray-200': !IS_MOBILE_APP }">
      <div v-if="IS_MOBILE_APP" class="flex items-center mb-7">
        <button class="flex py-2 pr-3" @click="onClose">
          <svg role="presentation" focusable="false" tabindex="-1" class="icon icon-sm rotate-90"
             
            alt="back"
            svg-inline
           xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 19"><title>back</title>
  <path fill="currentColor" fill-rule="evenodd"
    d="M.8 1.18a2.26 2.26 0 0 1 3.2 0L16 13.2 28.03 1.18a2.26 2.26 0 0 1 3.2 3.2L17.6 17.97c-.88.9-2.31.9-3.2 0L.8 4.39a2.26 2.26 0 0 1 0-3.2Z"
    clip-rule="evenodd" />
</svg>
        </button>
        <p class="text-20 font-semibold">{{ $t('transfer_search.search_for_transfer_deals') }}</p>
      </div>
      <h2 v-else class="text-24 md:text-30 font-semibold mb-5 mt-6 md:mt-0">
        {{ $t('transfer_search.compare_transfers') }}
      </h2>
      <MobileSearchForm v-if="IS_MOBILE_APP" />
      <TransferSearchForm v-else class="bg-white shadow-3 rounded-10" />
    </div>
  </MModal>
</template>

<script lang="ts" setup>
import { SearchModalOpen } from '@core/analytics/core-events/moneyTransfer'

const IS_MOBILE_APP = __IS_MOBILE_APP__
const MODAL_LINK_HASH = '#imt-search-modal'

withDefaults(defineProps<{ mountTo?: string }>(), { mountTo: 'body' })

const router = useRouter()
const { $track } = useNuxtApp()

const open = ref(false)

onMounted(() => {
  document.addEventListener('click', onClick, true)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', onClick, true)
})

function onClick(event: Event) {
  const link = event.target instanceof Element ? event.target.closest('a') : null
  if (link?.href.endsWith(MODAL_LINK_HASH)) {
    event.preventDefault()
    onLinkClick(link).catch(() => {
      // do nothing
    })
  }
}

async function onLinkClick(link: HTMLAnchorElement) {
  open.value = true
  await router.push({ hash: MODAL_LINK_HASH, query: router.currentRoute.value.query })
  const unregisterGuard = router.beforeEach((_to, _from, next) => {
    open.value = false
    unregisterGuard()
    next()
  })

  const slice = link.closest('[data-widget-type]')
  const id = link.closest('[id]')?.id
  await $track(
    SearchModalOpen({
      imtSearchModal: {
        linkLabel: link.innerText.trim(),
        sectionId: id === '__layout' ? undefined : id,
        sliceType: slice?.getAttribute('data-widget-type') ?? undefined,
        sliceTitle: slice?.getAttribute('data-widget-title') ?? undefined,
      },
    }),
  )
}

function onClose() {
  open.value = false
  if (router.currentRoute.value.hash === MODAL_LINK_HASH) {
    router.go(-1)
  }
}
</script>
